import * as React from 'react'
import { observer } from 'mobx-react'
import { getEventsTableHistory } from '../../../Model/TroubleEventsTableItem'
import ExportToCsvComponent from '../../../Components/ExportToCsvComponent'
import { ExportType } from '../../../Stores/ExportStore'
import PageSizeComponent from '../../../Components/PageSizeComponent'

export interface ITroubleEventsPageProps {

}

@observer
export default class TroubleEventsPage extends React.Component<ITroubleEventsPageProps> {
    render() {
        return (
            <div className="troubleEvents questionnaires row page">
                <div className="col-12">
                    <PageSizeComponent />
                    <ExportToCsvComponent exportType={ExportType.TroubleEventsList} />
                    {getEventsTableHistory()}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/TroubleEvent/TroubleEventsHistory.tsx